import { Injectable, Signal, WritableSignal, computed, inject, signal } from "@angular/core";
import { IQueueLocation, QueueLayoutAbstraction } from "@shared-core/general/queue/abstractions/queue-layout.abstraction";
import { QueuePreferencesService } from "./queue-preferences.service";

/**
 * Staff-app implementation of {@link QueueLayoutAbstraction}.
 *
 * The queue location is whatever the operator selected in their setup
 * preferences, so this adapter forwards `QueuePreferencesService.preferences`'s
 * location ({ id, name }) — already the shape the shared queue footer expects.
 * The full-screen kiosk pages (monitor, office-screen) drop in the queue
 * fullscreen guard, which registers `fullscreenToggle` so the shared header can
 * surface the fullscreen button.
 */
@Injectable()
export class QueueLayoutService implements QueueLayoutAbstraction {
  private readonly preferencesService = inject(QueuePreferencesService);

  readonly location: Signal<IQueueLocation | null> = computed(() => this.preferencesService.preferences()?.location ?? null);

  readonly fullscreenToggle: WritableSignal<(() => void) | null> = signal(null);
}
